function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillOpacity: 0.15,
  d: "M20.238 0L0 53.804V55h19.047L32.143 0H20.238zM54.76 0h11.905L53.571 55H34.524v-1.196L54.76 0z"
});

var SvgLeftQuote = function SvgLeftQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 55,
    viewBox: "0 0 67 55"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/left-quote.ca6757ca.svg";
export { SvgLeftQuote as ReactComponent };